<!--
  ~ Copyright (c) 1999 - 2019 Accorto, Inc. - All rights reserved.
  -->

<acc-login loginHeading="Accorto Login">
  <h2 class="slds-text-heading_medium">Professional Services Automation</h2>
  <summary class="slds-m-vertical_x-small">Accorto PSA Workbench</summary>
  <img alt="Accorto PSA Workbench - Copyright Accorto, Inc."
       src="/assets/images/logo.svg" style="float: right; height: 100px">
  <ul class="slds-list_dotted">
    <li>Manage Projects</li>
    <li>Manage Resources</li>
  </ul>
</acc-login>
